import {
    // RenderDeliveryOrder,
    // RenderSalesInvoice,
    RenderProduct,
} from "./document"

// const defaultSettings = {
//     pageSizeOptions: [],
//     pageOrientationOptions: [],
//     renderDataTypes: ["Full", "Without Footer"]
// }

// const defaultPropsDocument = {
//     pageSizeOptions: [],
//     pageOrientationOptions: [],
//     renderDataTypes: ['document', 'label']
// }

// const defaultPropsDocument2 = {
//     pageSizeOptions: [],
//     pageOrientationOptions: [],
//     renderDataTypes: []
// }

const defaultPropsDocument3 = {
    pageSizeOptions: [],
    pageOrientationOptions: [],
    renderDataTypes: ['label']
}


export const documentTypes = {
    // deliveryOrder: {
    //     id: "deliveryOrder",
    //     ...defaultPropsDocument,
    //     RenderFunction: RenderDeliveryOrder,
    // },
    // salesInvoice: {
    //     id: "salesInvoice",
    //     ...defaultPropsDocument2,
    //     RenderFunction: RenderSalesInvoice,
    // },
    product: {
        id: "product",
        ...defaultPropsDocument3,
        RenderFunction: RenderProduct,
    },
}